// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"07f06ae0","673":"631d821c"}[chunkId] + ".chunk.js";
};